export const alertsUrl = 'alerts/';
